import { render, staticRenderFns } from "./DraggerImg.vue?vue&type=template&id=096a001d&scoped=true"
import script from "./DraggerImg.vue?vue&type=script&lang=ts"
export * from "./DraggerImg.vue?vue&type=script&lang=ts"
import style0 from "./DraggerImg.vue?vue&type=style&index=0&id=096a001d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096a001d",
  null
  
)

export default component.exports